// src/components/CodeBlock.js
import React from 'react';
import styled from 'styled-components';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { tomorrow } from 'react-syntax-highlighter/dist/esm/styles/prism';

const CodeBlockContainer = styled.div`
  margin: ${({ theme }) => theme.spacing[3]} 0;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.divider};
  
  pre {
    margin: 0 !important;
    border-radius: 0 !important;
  }
`;

const CodeHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[3]}`};
  background-color: ${({ theme }) => theme.colors.backgroundDarker};
  border-bottom: 1px solid ${({ theme }) => theme.colors.divider};
  font-family: monospace;
  font-size: ${({ theme }) => theme.fonts.sizes.sm};
  color: ${({ theme }) => theme.colors.textSecondary};
`;


const CodeBlock = ({ code, language = 'javascript', filename = null, showHeader = true }) => {
    // Map common language identifiers to their syntax highlighter equivalents
    const languageMap = {
        'js': 'javascript',
        'jsx': 'jsx',
        'ts': 'typescript',
        'tsx': 'tsx',
        'py': 'python',
        'html': 'html',
        'css': 'css',
        'json': 'json',
        'bash': 'bash',
        'shell': 'bash',
        'sql': 'sql',
        'c': 'c',
        'cpp': 'cpp',
        'java': 'java',
        'go': 'go',
        'php': 'php',
        'ruby': 'ruby',
        'rust': 'rust',
        'csharp': 'csharp',
        'swift': 'swift',
        'xml': 'xml'
    };

    // Get the proper language identifier for syntax highlighting
    const highlightLanguage = languageMap[language.toLowerCase()] || language;

    // Get a display name for the language
    const displayLanguage = {
        'javascript': 'JavaScript',
        'jsx': 'JSX',
        'typescript': 'TypeScript',
        'tsx': 'TSX',
        'python': 'Python',
        'html': 'HTML',
        'css': 'CSS',
        'json': 'JSON',
        'bash': 'Bash',
        'sql': 'SQL',
        'c': 'C',
        'cpp': 'C++',
        'java': 'Java',
        'go': 'Go',
        'php': 'PHP',
        'ruby': 'Ruby',
        'rust': 'Rust',
        'csharp': 'C#',
        'swift': 'Swift',
        'xml': 'XML'
    }[highlightLanguage] || highlightLanguage;

    return (
        <CodeBlockContainer>
            {showHeader && (
                <CodeHeader>
                    <span>{filename || displayLanguage}</span>
                </CodeHeader>
            )}
            <SyntaxHighlighter
                language={highlightLanguage}
                style={tomorrow}
                showLineNumbers={true}
                wrapLines={true}
            >
                {code}
            </SyntaxHighlighter>
        </CodeBlockContainer>
    );
};

export default CodeBlock;